// Where a runner is on the course: the furthest checkpoint recorded, in course
// order, and the race time there. Shared by the results table (LAST CP column)
// and the runner modal, so both always say the same thing.

const toMs = (value) => {
  if (!value) return null;
  const ms = new Date(value?.toDate ? value.toDate() : value).getTime();
  return Number.isFinite(ms) ? ms : null;
};

// Milliseconds as HH:MM:SS race time (hours keep growing past 24).
export const formatRaceTime = (ms) => {
  const t = Math.max(0, Math.floor(ms / 1000));
  const h = Math.floor(t / 3600), m = Math.floor((t % 3600) / 60), s = t % 60;
  return [h, m, s].map((n) => String(n).padStart(2, "0")).join(":");
};

/**
 * @returns {null | { name: string, raceTime: string|null, finished: boolean }}
 *   null when nothing has been recorded for the runner.
 */
export const lastCheckpoint = (result, category) => {
  const cps = result?.checkpoints || {};
  if (toMs(cps.finish?.time) || toMs(result?.finishMatTime)) {
    return { name: "Finish", raceTime: null, finished: true };
  }
  let best = null;
  (category?.checkpoints || []).forEach((cp, i) => {
    const isMat = cp.type === "startfinish" || cp.type === "start";
    const ms = toMs(cps[isMat ? "start" : cp.locationId]?.time);
    if (ms == null) return;
    const order = isMat ? 0 : i + 1;
    if (!best || order > best.order) best = { order, name: isMat ? "Start" : cp.name, ms };
  });
  if (!best) return null;
  // Race time runs from the gun, or from the runner's own start reading in an
  // individual-start category.
  const baseMs = category?.individualStart ? toMs(cps.start?.time) : toMs(category?.startTime);
  return {
    name: best.name,
    raceTime: baseMs != null && best.ms >= baseMs ? formatRaceTime(best.ms - baseMs) : null,
    finished: false,
  };
};
